import API from '@/api'
import { addProtocol } from '../helpers'

interface ImportByLinkResponse {
  url: string
  title: string
  description: string
  image: {
    createdAt: string
    downloadUrl: string
    filename: string
    id: string
    size: number
    hSize: string
  } | null
  slug: string
  h1: string
  originalImage: string | null
}

export const importSeoTags = (
  projectId: string,
  url: string
): Promise<ImportByLinkResponse> => {
  const validUrl = addProtocol(url)

  return API.Import.seoTags({ projectId, url: validUrl })
    .then((response) => response)
    .catch((e) => {
      // biome-ignore lint/suspicious/noConsole: intentional
      console.log(e)
    })
}
